/**
 * This file defines global configuration data
 * @module config
 */

export default {

    /**
     * paths to image files
     * @type Object
     */
    paths: {
        sprite: '/images-1024/',
        full: '/images-2048/'
    },
    /**
     * View settings
     * @type Object
     */
    views: {
        random: {
            gridpadding: 8
        },
        time: {
            radius: 4,
            length: 360,
            spread: 1.25
        },
        color: {
            radius: 8,
            radiusGrowth: 14,
            height: 48
        },
        artist: {
            radius: 14
        }
    }
}